<template>
  <div class="LandingPageSale">
    <MainLogo />
    <Hero src="assets/landing-sale/hero.jpg">
      <h1>
        {{ $t('title') }}
      </h1>
      <h2>
        {{ $t('subtitle') }}
      </h2>
    </Hero>

    <div class="explanation">
      <h3 class="explanationTitle">
        {{ $t('explanationTitle') }}
      </h3>
      <p
        v-for="(paragraph, index) in $ta('explanationParagraphs')"
        :key="index"
        class="explanationParagraph">
        {{ paragraph }}
      </p>
    </div>

    <FormContactSale />

    <SectionPartners :doShowTitle="false" />

    <!-- <div class="listButton">
      <a
        class="Btn xl"
        :href="pdfLink"
        target="_blank">
        {{ $t('cta') }}
      </a>
    </div> -->

    <div class="contact">
      <h4 class="contactLabel">
        {{ $t('contactUs') }}
      </h4>
      <div class="contactDetails">
        {{ contactDetails }}
      </div>
    </div>
  </div>
</template>

<script>

import FormContactSale from './components/FormContactSale'
import Hero from 'views/components/Hero'
import MainLogo from 'views/components/TopBar/MainLogo'
import SectionPartners from 'views/components/SectionPartners'

export default {
  components: {
    MainLogo,
    Hero,
    SectionPartners,
    FormContactSale,
  },
  data() {
    return {
      contactDetails: 'info@nogrid.lt +370 691 02020',
      pdfLink: 'https://urbanwebstack-uploadspublicbucket-52in24jckklk.s3.amazonaws.com/nogrid_irangos_ispardavimas_v3_298ba47088.pdf',
    }
  },
}

</script>

<style lang="scss">
.LandingPageSale {
  background: $white;

  .Hero {
    height: 70vh;
    min-height: 40vh;
    @include md {
      height: 50vh;
    }
    @include lg {
      height: unset;
    }
  }

  .MainLogo {
    padding: 1rem 0 0 2rem;
    position: absolute;
    z-index: 2;
  }

  h1 {
    // font-size: $h1;
    letter-spacing: 0.05rem;
    margin-top: 1rem;
    text-align: center;
  }

  h2 {
    font-size: $h35;
    letter-spacing: 0.1rem;
    margin-top: 1rem;
    text-align: center;
    @include lg {
      font-size: 2.5rem;
    }
  }

  .hero-side-text {
    @include lg {
      padding-left: 20%;
    }
  }

  .Hero .image img {
    filter: brightness(0.5);
    height: 100%;
  }

  .explanation {
    background: $white;
    font-size: 1.5rem;
    font-weight: $bold;
    line-height: 1.5;
    padding: 4rem;
    text-align: center;
    @include lg {
      padding: 4rem 6rem;
    }
    @include xl {
      padding: 4rem 25rem;
    }

    .explanationTitle {
      font-size: $h4;
      font-weight: $bold;
      padding-bottom: 2rem;
    }

    .explanationParagraph {
      font-size: 1.2rem;
      padding-bottom: 1.2rem;
    }
  }

  .listButton {
    text-align: center;

    .Btn {
      font-size: 1.2rem;
      // padding: 2rem;
    }
  }

  .contact {
    padding-bottom: 4rem;
    text-align: center;

    .contactLabel {
      font-weight: $bold;
    }

    .contactDetails {
      font-size: 1.2rem;
      font-weight: $medium;
    }
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "NOGRID GERIAUSIOS KAINOS GARANTIJA!",
    "subtitle": "Pagrindinė saulės elektrinė įranga – palankiausiomis rinkos kainomis",
    "explanationTitle": "Kas yra geriausios kainos garantija?",
    "explanationParagraphs": [
      "Šiuo metu savo klientams siūlome geriausią kainos ir kokybės santykį rinkoje. Vadinasi, jog saulės modulius, įtampos keitiklius (inverterius) bei optimizatorius kviečiame įsigyti žemiausia kaina Lietuvoje.",
      "Jeigu ieškote mūsų siūlomų prekinių ženklų saulės modulių, įtampos keitiklių (inverterių) bei optimizatorių – pasidalinkite kitų tiekėjų kainomis ir mes jums suteiksime nuolaidą, kuri leis reikiamą įrangą įsigyti dar pigiau.",
      "Geriausios kainos pasiūlymas pagrindinei įrangai galioja tiek perkant saulės elektrinių įrangą atskirai, tiek saulės elektrinės įrengimą patikint „Nogrid“ komandai."
    ],
    "cta": "Peržiūrėti įrangos sąrašą",
    "contactUs": "Susisiekite su mumis"
  }
}
</i18n>
